import { render, staticRenderFns } from "./ProfileWizard.vue?vue&type=template&id=04918b40"
import script from "./ProfileWizard.vue?vue&type=script&lang=js"
export * from "./ProfileWizard.vue?vue&type=script&lang=js"
import style0 from "./ProfileWizard.vue?vue&type=style&index=0&id=04918b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports